module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/banner_header-e1f147091cd6943eaae66d38888d8bad.png";